import * as React from 'react';
import { RouteComponentProps, withRouter, Link } from 'react-router-dom';
import { Redirect } from 'react-router';
import axios from '../../helpers/axios';
import { Grid, Card, CardContent, CardHeader, IconButton, Button, Typography, CardActions, Modal, Box, Divider, Select, InputLabel, TextField, FormControl, MenuItem } from '@mui/material';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { withTranslation, WithTranslation } from 'react-i18next';
import OperationsHeader from './OperationsHeader';
import { DataGrid, GridRowParams, GridActionsCellItem, GridCellParams, GridToolbarContainer, GridToolbarExport } from '@mui/x-data-grid';
import { EditOutlined, Add, Security as SecurityIcon, FileCopy as FileCopyIcon, Download as DownloadIcon, CloseOutlined } from '@mui/icons-material';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '65%',
    p: 4,
};

function CustomToolbar() {
    return (
        <GridToolbarContainer className='exportButton'>
            <GridToolbarExport variant='contained' csvOptions={{ fileName: 'Expense-Tracking-List' }} />
        </GridToolbarContainer>
    );
}

export interface IProps {
    user: {
        id: number;
        name: string;
        email: string;
        role: string;
        is_active: boolean;
    };
}

export interface IState {
    expenses: any[];
    pageSize: number;
    showAddExpense: boolean;
    expenseTitle: string;
    expenseAccountName: string;
    expenseType: string;
    expenseAmount: number;
    expenseDate?: string | null;
    expenseDescription: string;
    expenseInvoice: number;
    expenseCreatedBy: string;
    expenseCreatedOn: string;
    expenseFile: string;
}

class Expenses extends React.Component<RouteComponentProps & IProps & WithTranslation, IState> {
    constructor(props: RouteComponentProps & IProps & WithTranslation) {
        super(props);
        this.state = {
            expenses: [],
            pageSize: 5,
            showAddExpense: false,
            expenseTitle: '',
            expenseAccountName: '',
            expenseType: '',
            expenseAmount: 0,
            expenseDate: null,
            expenseDescription: '',
            expenseInvoice: 0,
            expenseCreatedBy: '',
            expenseCreatedOn: '',
            expenseFile: ''
        }
    }
    public componentDidMount(): void {
        // axios.get(`expenses`).then(response => {
        //     this.setState({ expenses: response.data.data })
        // });
        this.setState({
            expenses: [
                {
                    "id": 1,
                    "expense_type": "Salary Drivers",
                    "amount": 3000,
                    "date": "2022-04-01",
                    "invoice": 3,
                    "created_by": "Made Darma",
                    "created_at": "2022-04-01 11:30",
                    "description": "Drivers Salary",
                    "attachment": "http://www.africau.edu/images/default/sample.pdf"
                },
                {
                    "id": 2,
                    "expense_type": "Health & LifeInsurance",
                    "amount": 32400,
                    "date": "2022-04-02",
                    "invoice": 1,
                    "created_by": "AGUS MIARSA",
                    "created_at": "2022-04-02 13:30",
                    "description": "Health and LifeInsurance",
                    "attachment": "http://www.africau.edu/images/default/sample.pdf"
                },
                {
                    "id": 3,
                    "expense_type": "Maintenance & Repair-Fuel",
                    "amount": 52100,
                    "date": "2022-04-03",
                    "invoice": 5,
                    "created_by": "Pak Batu",
                    "created_at": "2022-04-03 13:30",
                    "description": "Maintenance and Repair-Fuel",
                    "attachment": "http://www.africau.edu/images/default/sample.pdf"
                },
                {
                    "id": 4,
                    "expense_type": "Salary Drivers",
                    "amount": 3000,
                    "date": "2022-04-04",
                    "invoice": 4,
                    "created_by": "Made Darma",
                    "created_at": "2022-04-04 11:30",
                    "description": "Drivers Salary",
                    "attachment": "http://www.africau.edu/images/default/sample.pdf"
                },
                {
                    "id": 5,
                    "expense_type": "Health & LifeInsurance",
                    "amount": 32400,
                    "date": "2022-04-05",
                    "invoice": 2,
                    "created_by": "AGUS MIARSA",
                    "created_at": "2022-04-05 13:30",
                    "description": "Health and LifeInsurance",
                    "attachment": "http://www.africau.edu/images/default/sample.pdf"
                },
                {
                    "id": 6,
                    "expense_type": "Maintenance & Repair-Fuel",
                    "amount": 52100,
                    "date": "2022-04-06",
                    "invoice": 6,
                    "created_by": "Pak Batu",
                    "created_at": "2022-04-06 13:30",
                    "description": "Maintenance and Repair-Fuel",
                    "attachment": "http://www.africau.edu/images/default/sample.pdf"
                }
            ]
        })
    }

    public render() {
        if (!localStorage.getItem('token')) {
            return (
                <Redirect to="/login" />
            );
        }
        const { t } = this.props;

        const handleCellClick = (params: GridCellParams) => {
            console.log(params);
        };

        const handleAddExpense = (() => {
            this.setState({ showAddExpense: false });
            toast.success("Expense added", {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored"
            });
        });

        const columns: any = [
            {
                headerName: "Expenses",
                field: "expense_type",
                width: 180
            },
            {
                headerName: "Amount",
                field: "amount",
                type: "number",
                width: 100
            },
            {
                headerName: "Date",
                field: "date",
                type: "date",
                width: 100
            },
            {
                headerName: "Invoice",
                field: "invoice",
                type: "number",
                width: 80
            },
            {
                headerName: "Created By",
                field: "created_by",
                width: 150
            },
            {
                headerName: "Created On",
                field: "created_at",
                type: "dateTime",
                width: 150
            },
            {
                headerName: "Description",
                field: "description",
                width: 150
            },
            {
                headerName: "Attachment",
                field: "attachment",
                width: 120,
                renderCell: (params: GridCellParams) => (
                    <IconButton size="small" className='link' component={Link} to={params.row.attachment} download={true} target="_blank"><DownloadIcon className='link' /></IconButton>
                )
            },
            {
                headerName: "Actions",
                field: 'actions',
                type: 'actions',
                getActions: (params: GridRowParams) => [
                    <GridActionsCellItem
                        // icon={<FileCopyIcon />}    
                        label="Edit Expense Details"
                        onClick={() => console.log(params.id)}
                        showInMenu
                    />,
                    <GridActionsCellItem
                        label="Add Attachment"
                        onClick={() => console.log(params.id)}
                        showInMenu
                    />,
                    <GridActionsCellItem
                        label="Add Description"
                        onClick={() => console.log(params.id)}
                        showInMenu
                    />,
                    <GridActionsCellItem
                        label="Delete Expense"
                        onClick={() => console.log(params.id)}
                        showInMenu
                    />
                ]
            }
        ];

        return (
            <div>
                <ToastContainer
                    position="top-right"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop={true}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                />
                <OperationsHeader />
                <Grid container spacing={2}>
                    <Grid item md={12} xs={12} className="mt-3">
                        <Card>
                            <CardHeader
                                title="Expense Tracking"
                                className="text-left"
                                action={
                                    <CardActions>
                                        <Button size='small' variant='contained' className='link' 
                                        // component={Link} to={'/expense-maintenance-charts'}
                                        >View Bulk Upload Expenses</Button>
                                    </CardActions>
                                }
                            />
                            
                            <CardContent>
                                <Grid container spacing={2}>
                                    <Grid item md={12} xs={12} className="mt-3">
                                        <Card sx={{ boxShadow: 3 }}>
                                            <CardHeader
                                                title="Expense Tracking List"
                                                className="text-left"
                                                action={
                                                    <Button variant="contained" color="primary" size="small" sx={{ outline: 'none !important' }} fullWidth={true}>
                                                        <Add /> Add New Expense
                                                    </Button>
                                                }
                                            />
                                            <CardContent>
                                                <DataGrid
                                                    aria-label="Expense Tracking List"
                                                    columns={columns}
                                                    rows={this.state.expenses}
                                                    pageSize={this.state.pageSize}
                                                    onPageSizeChange={(newPageSize) => this.setState({ pageSize: newPageSize })}
                                                    rowsPerPageOptions={[2, 5, 10, 20]}
                                                    autoHeight={true}
                                                    components={{
                                                        MoreActionsIcon: EditOutlined,
                                                        Toolbar: CustomToolbar
                                                    }}
                                                    componentsProps={{ toolbar: { csvOptions: { fileName: 'Tickets-list' } } }}
                                                    checkboxSelection
                                                />
                                            </CardContent>
                                        </Card>
                                    </Grid>
                                </Grid>
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
                <Modal
                    open={this.state.showAddExpense}
                    onClose={() => this.setState({ showAddExpense: false })}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                        <Card>
                            <CardHeader
                                title="Add Vehicle"
                                className="text-left"
                                action={
                                    <IconButton color="primary" className='customIconButton' aria-label="upload picture" component="span" onClick={() => this.setState({ showAddExpense: false })}>
                                        <CloseOutlined />
                                    </IconButton>
                                }
                            />
                            <CardContent>
                                <Divider className="mb-3" />
                                <Grid container spacing={2}>
                                    <Grid item md={4} xs={12}>
                                        <FormControl fullWidth={true}>
                                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                <DatePicker
                                                    renderInput={(props) => <TextField {...props} />}
                                                    label="Date *"
                                                    views={['year', 'month', 'day']}
                                                    value={this.state.expenseDate}
                                                    onChange={(newValue: any) => {
                                                        this.setState({ expenseDate: newValue });
                                                    }}
                                                />
                                            </LocalizationProvider>
                                        </FormControl>
                                    </Grid>
                                    {/* <Grid item md={4} xs={12}>
                                        <TextField
                                            id="mocciid-input"
                                            label="Mocciid *"
                                            value={this.state.vehicleMocciid}
                                            onChange={(e: any) => this.setState({ vehicleMocciid: e.target.value })}
                                            fullWidth={true}
                                        />
                                    </Grid>
                                    <Grid item md={4} xs={12}>
                                        <TextField
                                            id="banjar-input"
                                            label="Banjar *"
                                            value={this.state.vehicleBanjar}
                                            onChange={(e: any) => this.setState({ vehicleBanjar: e.target.value })}
                                            fullWidth={true}
                                        />
                                    </Grid>
                                    <Grid item md={4} xs={12}>
                                        <FormControl fullWidth={true}>
                                            <InputLabel id="vendor-label">Vendor *</InputLabel>
                                            <Select
                                                labelId="vendor-label"
                                                value={this.state.vehicleVendor}
                                                onChange={(e) => this.setState({ vehicleVendor: e.target.value })}
                                                displayEmpty
                                                label="Vendor *"
                                                fullWidth={true}
                                            >
                                                <MenuItem key={1} value={'TATA Motors'}>TATA Motors</MenuItem>
                                                <MenuItem key={2} value={'Benz'}>Benz</MenuItem>
                                                <MenuItem key={3} value={'ISUZU'}>ISUZU</MenuItem>
                                                <MenuItem key={4} value={'Volvo'}>Volvo</MenuItem>
                                                <MenuItem key={5} value={'Mitsubishi'}>Mitsubishi</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item md={4} xs={12}>
                                        <TextField
                                            id="vehicle-amount-input"
                                            label="Amount/Cost (IN RP) *"
                                            type={'number'}
                                            InputProps={{
                                                inputProps: { min: 0 }
                                            }}
                                            value={this.state.vehicleAmount}
                                            onChange={(e: any) => this.setState({ vehicleAmount: e.target.value })}
                                            fullWidth={true}
                                        />
                                    </Grid>
                                    <Grid item md={4} xs={12}>
                                        <TextField
                                            id="vehicle-age-input"
                                            label="Age (In Years) *"
                                            type={'number'}
                                            InputProps={{
                                                inputProps: { min: 0 }
                                            }}
                                            value={this.state.vehicleAge}
                                            onChange={(e: any) => this.setState({ vehicleAge: e.target.value })}
                                            fullWidth={true}
                                        />
                                    </Grid>
                                    <Grid item md={4} xs={12}>
                                        <FormControl fullWidth={true}>
                                            <InputLabel id="condition-label">Condition *</InputLabel>
                                            <Select
                                                labelId="condition-label"
                                                value={this.state.vehicleCondition}
                                                onChange={(e) => this.setState({ vehicleCondition: e.target.value })}
                                                displayEmpty
                                                label="Condition *"
                                                fullWidth={true}
                                            >
                                                <MenuItem key={1} value={'Good'}>Good</MenuItem>
                                                <MenuItem key={2} value={'Average'}>Average</MenuItem>
                                                <MenuItem key={3} value={'Bad'}>Bad</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Grid> */}
                                </Grid>
                                <Divider className='mt-3' />
                            </CardContent>
                            <CardActions className='float-right'>
                                <Button size='small' className='customCloseButton' onClick={() => this.setState({ showAddExpense: false })}>Close</Button>
                                <Button size='small' variant='contained' sx={{ outline: 'none !important' }} onClick={() => handleAddExpense()}>Add Vehicle</Button>
                            </CardActions>
                        </Card>
                    </Box>
                </Modal>
            </div>
        )
    }
}

export default withRouter(withTranslation()(Expenses))